import React, { Component } from "react";
import {
	View,
	Text,
	StyleSheet,
	KeyboardAvoidingView,
	TextInput,
	Button,
	Alert,
	Platform,
	ImageBackground,
	Image,
	AsyncStorage,
} from "react-native";

import SafeAreaView from "components/third-party/react-native-safe-area-view"

import { autoLogin, refresh } from "utils/awsAuth";
import { reset } from "utils/navigation";
import { translate } from "react-i18next";
import HomeButton from "components/HomeButton";
import ArrowLeft from "components/svgs/ArrowLeft";


import * as x from "../../styles/css";

class UnitDetail extends Component {
	static navigationOptions = {
		header: null,
	};

	static isPrivate = true;

	constructor(props) {
		super(props);

		this.state = {
			deviceId: null,
			softwareVersion: 1.0,
			fanRunningHours: 1,
			pumpRunningHours: 1,
			defaultColor: x.colors.primaryGlass,
			shadowDetails: null
		}
	}

	componentDidMount() {
		let shadowDetails = AsyncStorage.getItem("shadowDetails");
		this.setState({ shadowDetails: JSON.parse(shadowDetails) },
		() => {
			this.setState({
				softwareVersion: this.state.shadowDetails.version,
				fanRunningHours: this.state.shadowDetails.fanRunTime,
				pumpRunningHours: this.state.shadowDetails.pumpRunTime,
			})
		});
		console.log(JSON.parse(shadowDetails));
	}

	render() {
		const { t } = this.props;
		return (
			<View style={[x.d.flex]}>
				<ImageBackground
					style={[
						x.d.flex,
						x.justifyContent.center,
						x.alignItems.center,
						{ height: "100%", width: "100%" },
					]}
					resizeMode="cover"
					blurRadius={1}
					source={require("assets/bg.fw.jpg")}
				>
					<SafeAreaView style={[
						x.d.flex,
						x.justifyContent.center,
						x.alignItems.center,
						{ height: "100%", width: "100%" },
					]}>

					<View
						style={{
							backgroundColor: "rgba(0,0,0,0)"
						}}
					>
						<Text style={{ fontSize: 24, color: "white" }}>
                            {"Unit Detail"}
                        </Text>
						{
							(this.state.shadowDetails)
							?
							<Text style={{ fontSize: 18, color: "white" }}>
								{"Software Version : " + this.state.softwareVersion + "\n" + "Fan Running Hours : " + this.state.fanRunningHours + "\n" + "Pump Running Hours : " + this.state.pumpRunningHours}
							</Text>
							:
							<Text style={{ fontSize: 24, color: "white" }}>
                            	{"Loading..."}
                        	</Text>
						}

					</View>
					</SafeAreaView>
				</ImageBackground>
			</View>
		);
	}
}

export default  translate()(UnitDetail);



// WEBPACK FOOTER //
// ./src/views/UnitDetail/index.js